import { DiagnosticServiceModel } from './diagnostic.service.model';
import { DiagnosticServiceGroupType } from '../enums';

export class DiagnosticServiceGroupModel {
    name: string;
    type: DiagnosticServiceGroupType;
    children: DiagnosticServiceGroupModel[];
    diagnosticServices: DiagnosticServiceModel[];
}
